"use client";
import React from 'react';
import styles from './BlogStartSection.module.css';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';
import keyboard from "../../src/assets/icons/keyboard.svg";
import folder from "../../src/assets/icons/folder.svg";
import { useRouter } from "next/navigation";

const BlogStartSection = ({ title, author, category, image, alt }) => {
  const { t } = useTranslation();
  const router = useRouter(); 

  const getSlug = (text) => text?.toLowerCase().replace(/\s+/g, "-");

  const handleCategoryClick = () => {
    router.push(`/blogs/category/${getSlug(category)}`);
  };
  var startCategory = "";
  if(category==="retirees-equity-release"){
    startCategory= "Retirees Equity Release"
  }else if(category==="new-blogs"){
    startCategory="New Blogs"
  }else if(category==="fact-sheets"){
    startCategory="Fact Sheets"
  }else if(category==="insights"){
    startCategory="Insights"
  }else if(category==="e-book"){
    startCategory="E Book"
  }

  return (
    <div className={styles.blogStartContainer}>
      <div className={styles.blogHeader}>
        <h1 className={styles.blogTitle}>{t(title)}</h1>
        <div className={styles.blogMetaInfo}>
          <div className={styles.metaItem} onClick={() => router.push('/blogs/author/keychoice/')}>
            <Image src={keyboard} alt="Author" width={22} height={22} style={{ marginBottom: "6px" }} />
            <span className={styles.metaText}>{t(author)}</span>
          </div>
          <div
            className={styles.metaItem}
            onClick={handleCategoryClick}
            role="button"
            tabIndex={0}
            style={{ cursor: "pointer" }} 
          >
            <Image src={folder} alt="Category" />
            <span className={styles.metaText}>
              {t(startCategory)}
            </span>
          </div>
        </div>
      </div>
      <div className={styles.blogImageContainer}>
        <Image
          src={image}
          alt={alt || t('Blog featured image')}
          className={styles.blogImage}
          loading='eager'
          priority
          height="auto"
        />
      </div>
    </div>
  );
};

export default BlogStartSection;
